import React from 'react';

import { containerClass, listClass, listItemClass } from './style.css';

export interface ReportIndexProps {
	indexItems: string[];
	selectedSection?: string;
	handleMoveScroll?: (section: string) => void;
	isNoTab?: boolean;
}

const ReportIndex = ({
	indexItems,
	selectedSection,
	handleMoveScroll,
	isNoTab,
}: ReportIndexProps) => {
	return (
		<div className={containerClass({ isNoTab })}>
			<ul className={listClass}>
				{indexItems.map((item, idx) => (
					<li
						key={idx}
						className={listItemClass({ isSelected: selectedSection === item })}
						onClick={() => handleMoveScroll?.(item)}
						onKeyDown={() => handleMoveScroll?.(item)}
					>
						{item}
					</li>
				))}
			</ul>
		</div>
	);
};

export default ReportIndex;
